import React from 'react';
import { Link } from 'react-router-dom';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import imgSatyam from '../../assets/images/testimonial/satyam.png';
import imgSavaliya from '../../assets/images/testimonial/savaliya.jpg';
import imgStavya from '../../assets/images/testimonial/brand-1-7.jpg';
import imgsevenStar from '../../assets/images/testimonial/7Star.png';
// import testimonialImg3 from '../../assets/images/testimonial/testimonial-1-3.jpg';
// import testimonialImg4 from '../../assets/images/testimonial/testimonial-1-4.jpg';

const swiperOptions = {
    modules: [Autoplay, Pagination, Navigation],
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 2000,
    loop: true,
    pagination: {
        el: '.swiper-dot-style1',
        type: 'bullets',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next1',
        prevEl: '.swiper-button-prev1',
    },
    autoplay: { delay: 9000 },
    breakpoints: {
        0: {
            spaceBetween: 0,
            slidesPerView: 1,
        },
        375: {
            spaceBetween: 0,
            slidesPerView: 1,
        },
        575: {
            spaceBetween: 0,
            slidesPerView: 1,
        },
        768: {
            spaceBetween: 30,
            slidesPerView: 1,
        },
        992: {
            spaceBetween: 30,
            slidesPerView: 1,
        },
        1200: {
            spaceBetween: 30,
            slidesPerView: 1,
        },
        1320: {
            spaceBetween: 30,
            slidesPerView: 1,
        },
    },
};

export default function TestimonialSlider1() {
    return (
        <Swiper {...swiperOptions} className="thm-swiper__slider swiper-container">
            <SwiperSlide className="swiper-slide">
                <Link to="/testimonials" className="testimonial-one__single-link" aria-label="View all testimonials">
                    <div className="testimonial-one__single">
                        {/* <div className="testimonial-one__quote">
                            <span className="icon-quote" />
                        </div> */}
                        <div className="testimonial-one__client-img">
                            <img src={imgSatyam} alt="Testimonial from Satyam Developers" />
                        </div>
                        <div className="testimonial-one__ratting">
                            <span className="icon-star" />
                            <span className="icon-star" />
                            <span className="icon-star" />
                            <span className="icon-star" />
                            <span className="icon-star last-star" />
                        </div>
                        <h3 className="testimonial-one__client-name">
                            Satyam Developers
                        </h3>
                        <p className="testimonial-one__client-sub-title">
                            Shraddha Residency
                        </p>
                        <p className="testimonial-one__text">
                            ArchElevators delivered reliable and high-quality lift solutions for our residential project, ensuring smooth coordination and timely execution.
                        </p>
                    </div>
                </Link>
            </SwiperSlide>
            <SwiperSlide className="swiper-slide">
                <Link to="/testimonials" className="testimonial-one__single-link" aria-label="View all testimonials">
                    <div className="testimonial-one__single">
                        {/* <div className="testimonial-one__quote">
                            <span className="icon-quote" />
                        </div> */}
                        <div className="testimonial-one__client-img">
                            <img src={imgSavaliya} alt="Testimonial from Savaliya" />
                        </div>
                        <div className="testimonial-one__ratting">
                            <span className="icon-star" />
                            <span className="icon-star" />
                            <span className="icon-star" />
                            <span className="icon-star" />
                            <span className="icon-star last-star" />
                        </div>
                        <h3 className="testimonial-one__client-name">
                            Savaliya Builders
                        </h3>
                        <p className="testimonial-one__client-sub-title">
                            Sun Gold
                        </p>
                        <p className="testimonial-one__text">
                            The team demonstrated strong technical expertise and professionalism, contributing significantly to the successful completion of our elevator installation.
                        </p>
                    </div>
                </Link>
            </SwiperSlide>
            <SwiperSlide className="swiper-slide">
                <Link to="/testimonials" className="testimonial-one__single-link" aria-label="View all testimonials">
                    <div className="testimonial-one__single">
                        {/* <div className="testimonial-one__quote">
                            <span className="icon-quote" />
                        </div> */}
                        <div className="testimonial-one__client-img">
                            <img src={imgStavya} alt="Testimonial from Stavya Spine Hospital" />
                        </div>
                        <div className="testimonial-one__ratting">
                            <span className="icon-star" />
                            <span className="icon-star" />
                            <span className="icon-star" />
                            <span className="icon-star" />
                            <span className="icon-star last-star" />
                        </div>
                        <h3 className="testimonial-one__client-name">
                            Stavya Spine Hospital
                        </h3>
                        <p className="testimonial-one__client-sub-title">
                            &nbsp;
                        </p>
                        <p className="testimonial-one__text">
                            Working with ArchElevators was a seamless experience throughout our Elevators project. The team demonstrated clarity in understanding requirements, proactive involvement in design and configuration, and consistent attention during execution.
                        </p>
                    </div>
                </Link>
            </SwiperSlide>
            <SwiperSlide className="swiper-slide">
                <Link to="/testimonials" className="testimonial-one__single-link" aria-label="View all testimonials">
                    <div className="testimonial-one__single">
                        {/* <div className="testimonial-one__quote">
                            <span className="icon-quote" />
                        </div> */}
                        <div className="testimonial-one__client-img">
                            <img src={imgsevenStar} alt="Testimonial from Seven Star Real Estate Developers" />
                        </div>
                        <div className="testimonial-one__ratting">
                            <span className="icon-star" />
                            <span className="icon-star" />
                            <span className="icon-star" />
                            <span className="icon-star" />
                            <span className="icon-star last-star" />
                        </div>
                        <h3 className="testimonial-one__client-name">
                            Seven Star Real Estate Developers
                        </h3>
                        <p className="testimonial-one__client-sub-title">
                            Platinum gold
                        </p>
                        <p className="testimonial-one__text">
                            Their commitment to quality, safety, and timely delivery made our elevator project smooth and hassle-free.
                        </p>
                    </div>
                </Link>
            </SwiperSlide>
            <SwiperSlide className="swiper-slide">
                <Link to="/testimonials" className="testimonial-one__single-link" aria-label="View all testimonials">
                    <div className="testimonial-one__single">
                        {/* <div className="testimonial-one__quote">
                            <span className="icon-quote" />
                        </div> */}
                        {/* <div className="testimonial-one__client-img">
                            <img src="" alt="Testimonial from Mr. Kaushalbhai Trivedi" />
                        </div> */}
                        <div className="testimonial-one__ratting">
                            <span className="icon-star" />
                            <span className="icon-star" />
                            <span className="icon-star" />
                            <span className="icon-star" />
                            <span className="icon-star last-star" />
                        </div>
                        <h3 className="testimonial-one__client-name">
                            Mr. Kaushalbhai Trivedi
                        </h3>
                        <p className="testimonial-one__client-sub-title">
                            Private Residence
                        </p>
                        <p className="testimonial-one__text">
                            We recently got this lift installed at our residence, and we are extremely happy with the result. The lift runs very smoothly, is quiet in operation, and feels safe and reliable.
                        </p>
                    </div>
                </Link>
            </SwiperSlide>
            <SwiperSlide className="swiper-slide">
                <Link to="/testimonials" className="testimonial-one__single-link" aria-label="View all testimonials">
                    <div className="testimonial-one__single">
                        {/* <div className="testimonial-one__quote">
                            <span className="icon-quote" />
                        </div> */}
                        {/* <div className="testimonial-one__client-img">
                            <img src="" alt="Testimonial from Dr. Bhatia" />
                        </div> */}
                        <div className="testimonial-one__ratting">
                            <span className="icon-star" />
                            <span className="icon-star" />
                            <span className="icon-star" />
                            <span className="icon-star" />
                            <span className="icon-star last-star" />
                        </div>
                        <h3 className="testimonial-one__client-name">
                            Dr. Bhatia
                        </h3>
                        <p className="testimonial-one__client-sub-title">
                            Private Residence
                        </p>
                        <p className="testimonial-one__text">
                            I am Dr Bhatia, a retired Govt. office aged 72, and after installing a lift at my home, I found the team highly efficient and dependable.
                        </p>
                    </div>
                </Link>
            </SwiperSlide>
            {/* <SwiperSlide className="swiper-slide">
                <div className="testimonial-one__single">
                    <div className="testimonial-one__quote">
                        <span className="icon-quote" />
                    </div>
                    <div className="testimonial-one__client-img">
                        <img src={testimonialImg4} alt="Testimonial from Mainto Vula" />
                    </div>
                    <div className="testimonial-one__ratting">
                        <span className="icon-star" />
                        <span className="icon-star" />
                        <span className="icon-star" />
                        <span className="icon-star" />
                        <span className="icon-star last-star" />
                    </div>
                    <h3 className="testimonial-one__client-name">
                        Mainto Vula
                    </h3>
                    <p className="testimonial-one__client-sub-title">
                        Manager
                    </p>
                    <p className="testimonial-one__text">
                        Logistic service involves the planning implementation and control of the efficient and effective movement and storage of goods and materials.
                    </p>
                </div>
            </SwiperSlide> */}
        </Swiper>
    );
}
